const {
  NODE_ENV,
  REACT_APP_API_BASEURL,
  REACT_APP_CABINET_BASEURL = '',
  REACT_APP_HW_ONLINE = '',
} = process.env

export const env = {
  isDev: NODE_ENV === 'production',
  baseUrl: REACT_APP_API_BASEURL,
  cabinetLink: REACT_APP_CABINET_BASEURL,
  hwOnline: REACT_APP_HW_ONLINE,
}
